export enum DocumentStatus {
  NOT_STARTED = "NOT_STARTED",
  DRAFT = "DRAFT",
  TECH_REVIEW = "TECH_REVIEW",
  READY_FOR_EDITOR = "READY_FOR_EDITOR",
  EDITOR_REVIEW = "EDITOR_REVIEW",
  CLIENT_REVIEW = "CLIENT_REVIEW",
  FINAL = "FINAL"
}
